/* ==========================================================================
   CheckboxToggle > Config
   ========================================================================== */

const configuration = {
    component: 'CheckboxToggle',
    init: true,
    css: {
        base: 'checkbox-toggle',
        valid: 'is-valid',
        error: 'has-error',
        active: 'is-active'
    },
    onChange: []
};

const config = () => configuration;

module.exports = config;
